import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import AuthForm from './AuthForm';

const LOGO_URL = '/images/pkab-horizsm.png';

export default function OrderingGate({ children }) {
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | unauthenticated | authorized

  useEffect(() => {
    async function checkSession(sess) {
      if (!sess) {
        setStatus('unauthenticated');
        return;
      }

      // Check if this user is a coordinator — redirect them to their company page
      const { data: profile } = await supabase
        .from('profiles')
        .select('corporate_client_id, corporate_clients(slug)')
        .eq('id', sess.user.id)
        .single();

      const slug = profile?.corporate_clients?.slug;
      if (slug) {
        navigate(`/c/${slug}`, { replace: true });
        return;
      }

      // Regular customer — show the ordering form
      setStatus('authorized');
    }

    supabase.auth.getSession().then(({ data: { session } }) => {
      checkSession(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        checkSession(session);
      } else {
        setStatus('unauthenticated');
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  if (status === 'loading') {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blush-300" />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return (
      <div className="min-h-screen bg-warmwhite flex flex-col items-center justify-center px-4 py-12 gap-6">
        <div className="text-center space-y-2">
          <img
            src={LOGO_URL}
            alt="Phoenix Kabob"
            className="h-14 w-auto mx-auto mb-2"
            onError={e => { e.target.style.display = 'none'; }}
          />
          <h2 className="text-3xl font-serif text-charcoal">Sign in to order</h2>
          <p className="text-sage-500 text-sm">
            Sign in to your account or create a new one to place an order.
          </p>
        </div>
        <AuthForm initialMode="login" allowSignup={true} />
      </div>
    );
  }

  return children;
}
